import React, { useState, useEffect, useRef } from "react";
import styles from "../styles_home/CustomerJourney.module.css";

const CustomerJourney = () => {
  const [isVisible, setIsVisible] = useState(false);
  const timelineRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (timelineRef.current) {
        const topPosition = timelineRef.current.getBoundingClientRect().top;
        if (topPosition < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Check visibility on mount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const steps = [
    {
      title: "Discovery & Analysis",
      phase: "Phase 1",
      description: "Comprehensive analysis of business requirements and objectives",
      icon: "🔍"
    },
    {
      title: "Strategic Planning",
      phase: "Phase 2",
      description: "Development of detailed technical architecture and roadmap",
      icon: "📋"
    },
    {
      title: "Implementation",
      phase: "Phase 3",
      description: "Execution of development using cutting-edge technologies",
      icon: "⚡"
    },
    {
      title: "Quality Assurance",
      phase: "Phase 4",
      description: "Thorough testing and performance optimization",
      icon: "✓"
    },
    {
      title: "Deployment & Support",
      phase: "Phase 5",
      description: "Launch, monitoring, and continuous improvement",
      icon: "🚀"
    }
  ];

  return (
    <div ref={timelineRef} className={styles.journeyContainer}>
      <div className={styles.headerSection}>
        <h1>Customer Journey</h1>
        <p>A systematic approach to deliver exceptional results</p>
      </div>
      <ul className={styles.timeline}>
        {steps.map((step, index) => (
          <li 
            key={index} 
            className={`${styles.timelineItem} ${isVisible ? styles.visible : ''}`}
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <div className={styles.timelineIcon}>{step.icon}</div>
            <div className={styles.timelineContent}>
              <h3>
                {step.title}
                <time>{step.phase}</time>
              </h3>
              <p>{step.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomerJourney;